import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useRewardStore = defineStore('reward', () => {
  // State
  const otherRewardList = ref([])
  const pointsRewardList = ref([])
  const rewardList = ref([])
  const activityNo = ref(null)
  const receiveNo = ref(null)
  const withdrawRule = ref({})
  const rewardType = ref(null)
  const isPlaying = ref(false)
  const callback = ref(null)
  const orderColumn = ref('createTime')
  const lang = ref('en-US')
  const receiving = ref(false)
  const pending = ref(false)
  // 清單寫入當下的身分識別碼（由當下 token 導出的不可逆雜湊，非原始 token）。
  // 送出領獎前用它比對，攔下「用 A 的 token 送出 B 的 receiveNo」（TI-15612）。
  const rewardListOwnerKey = ref(null)

  // Getters
  const getPending = computed(() => pending.value)

  // Actions
  // 請求被取消時 $request.send 會回傳 { data: {} }（見 plugins/01.request.js），
  // 為避免下游 .filter() 因型別錯誤崩潰，於 setter 統一強制成 array。
  //
  // ownerKey 省略時不蓋章：歸屬校驗為 fail-open，未蓋章的路徑一律放行。
  function stampOwner(data, ownerKey) {
    const list = Array.isArray(data) ? data : []
    if (!ownerKey) {
      return list
    }
    return list.map((item) => (item && typeof item === 'object' ? { ...item, ownerKey } : item))
  }

  function setOtherRewardList(data, ownerKey) {
    otherRewardList.value = stampOwner(data, ownerKey)
    if (ownerKey) rewardListOwnerKey.value = ownerKey
  }

  function setPointsRewardList(data, ownerKey) {
    pointsRewardList.value = stampOwner(data, ownerKey)
    if (ownerKey) rewardListOwnerKey.value = ownerKey
  }

  function setRewardList(data, ownerKey) {
    rewardList.value = stampOwner(data, ownerKey)
    if (ownerKey) rewardListOwnerKey.value = ownerKey
  }

  function setActivityNo(data) {
    activityNo.value = data
  }

  function setReceiveNo(data) {
    receiveNo.value = data
  }

  function setWithdrawRule(data) {
    withdrawRule.value = data
  }

  function setRewardType(data) {
    rewardType.value = data
  }

  function setIsPlaying(data) {
    isPlaying.value = data
  }

  function setCallback(data) {
    callback.value = data
  }

  function setOrderColumn(data) {
    orderColumn.value = data
  }

  function setLang(data) {
    lang.value = data
  }

  function setReceiving(data) {
    receiving.value = data
  }

  function setPending(data) {
    pending.value = data
  }

  function resetPendingState() {
    pending.value = false
    withdrawRule.value = {}
    activityNo.value = null
    receiveNo.value = null
  }

  // 換身分 / 登出時清空本帳號的獎勵資料（TI-15612）。
  // 三份清單是收件匣與全民代理畫面的唯一來源，殘留即等於「畫面上出現別人的 receiveNo」。
  // isPlaying / orderColumn / lang 屬 UI 偏好，不隨身分變動，故不清。
  function resetUserScoped() {
    otherRewardList.value = []
    pointsRewardList.value = []
    rewardList.value = []
    rewardListOwnerKey.value = null
    rewardType.value = null
    callback.value = null
    receiving.value = false
    resetPendingState()
  }

  return {
    // State
    otherRewardList,
    pointsRewardList,
    rewardList,
    rewardListOwnerKey,
    activityNo,
    receiveNo,
    withdrawRule,
    rewardType,
    isPlaying,
    callback,
    orderColumn,
    lang,
    receiving,
    pending,

    // Getters
    getPending,

    // Actions
    setOtherRewardList,
    setPointsRewardList,
    setRewardList,
    setActivityNo,
    setReceiveNo,
    setWithdrawRule,
    setRewardType,
    setIsPlaying,
    setCallback,
    setOrderColumn,
    setLang,
    setReceiving,
    setPending,
    resetPendingState,
    resetUserScoped,
  }
})
